import React from 'react'
import PropTypes from 'prop-types'
import gql from 'graphql-tag'
import BookingsListItem from 'components/shared/BookingsListItem'

const BookingsList = ({bookings}) => {
  return (
    <div className="bookings-list">
      {bookings.edges.map(({node: booking}) =>
        <BookingsListItem
          key={booking.id}
          booking={booking}
        />
      )}
    </div>
  )
}

BookingsList.propTypes = {
  bookings: PropTypes.object,
}

BookingsList.fragments = {
  bookingsList: gql`
    fragment BookingsList on BookingsConnection {
      edges {
        node {
          ...BookingsListItem
        }
      }
    }
    ${BookingsListItem.fragments.booking}
  `,
}

export default BookingsList
